// packages import
import { Autocomplete, TextField } from '@mui/material'
import { FC, useContext } from 'react'

// others
import { BillStatus } from '../../../../../generated'
import { FundRequestsContext } from '../../../../context/FundRequestsContext'
import { formatStatus } from '../../../../utils/billing'
import { FINAL_BILL_STATUSES, VOID_BILL_STATUSES } from '../../../../constants'

interface StatusOption {
  value: BillStatus
  label: string
}

const statusOptions: StatusOption[] = [
  ...FINAL_BILL_STATUSES.filter(status => status !== BillStatus.PrePaid),
  ...VOID_BILL_STATUSES.filter(status => status !== BillStatus.WrittenOff && status !== BillStatus.Forwarded)
].map(status => ({
  value: status,
  label: formatStatus(status)
}))

const StatusFilter: FC = () => {
  const { filters, setFilters } = useContext(FundRequestsContext)

  const selectedStatus = statusOptions.find(status => status.value === filters.status) || null

  const handleStatusChange = (value: StatusOption | null) => {
    setFilters({ status: value?.value })
  }

  return (
    <Autocomplete
      sx={{ minWidth: 200 }}
      options={statusOptions}
      value={selectedStatus}
      onChange={(_, value) => handleStatusChange(value)}
      getOptionLabel={option => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      renderInput={params => <TextField {...params} label="Status" />}
    />
  )
}

export default StatusFilter
